import { render, staticRenderFns } from "./AdminTransactionRejectButton.vue?vue&type=template&id=f8aecdd8&"
import script from "./AdminTransactionRejectButton.vue?vue&type=script&lang=ts&"
export * from "./AdminTransactionRejectButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports